import { render, staticRenderFns } from "./LeadCustomerModal.vue?vue&type=template&id=3f56bfbe&scoped=true&"
import script from "./LeadCustomerModal.vue?vue&type=script&lang=js&"
export * from "./LeadCustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./LeadCustomerModal.vue?vue&type=style&index=0&id=3f56bfbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f56bfbe",
  null
  
)

export default component.exports